import apiFetch from '../../apiFetch'

export default function (token, processingAgencyId, processingAgencyDocTypeUsesId) {
  return apiFetch({ endPoint: `ProcessingAgency/${processingAgencyId}/DocTypeUses/${processingAgencyDocTypeUsesId}`, method: 'DELETE', body: null, token: token })
}
